/** sessionStorage key for modal→frame Starting Chat handoff timestamp */
export const CHAT_HANDOFF_STARTING_AT_KEY = 'coachChatHandoffStartingAt'

/** Max age for Starting Chat before an abandoned (frame never joined) handoff is hidden */
export const STARTING_CHAT_HANDOFF_TTL_MS = 30000

/**
 * Flag navigation so RtcService skips unload disconnect during handoff.
 */
export const markChatHandoffNavigation = () => {
  if (typeof window !== 'undefined') {
    window.leavingRoom = true
  }
}

/**
 * Persist handoff start time so the chat frame can clear the abandoned-load TTL.
 *
 * @param {number} startingChatAt
 */
export const storeChatHandoffStartingAt = (startingChatAt) => {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  try {
    sessionStorage.setItem(CHAT_HANDOFF_STARTING_AT_KEY, String(startingChatAt))
  } catch (error) {
    console.warn('chatHandoff - Failed to store startingChatAt:', error)
  }
}

/**
 * @returns {number|null}
 */
export const readChatHandoffStartingAt = () => {
  if (typeof sessionStorage === 'undefined') {
    return null
  }
  try {
    const raw = sessionStorage.getItem(CHAT_HANDOFF_STARTING_AT_KEY)
    if (!raw) {
      return null
    }
    const value = Number(raw)
    return Number.isFinite(value) ? value : null
  } catch (error) {
    console.warn('chatHandoff - Failed to read startingChatAt:', error)
    return null
  }
}

export const clearChatHandoffStartingAt = () => {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  try {
    sessionStorage.removeItem(CHAT_HANDOFF_STARTING_AT_KEY)
  } catch (error) {
    console.warn('chatHandoff - Failed to clear startingChatAt:', error)
  }
}
